import { Injectable, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { NotificationService } from 'src/app/shared/services/notification.service';


@Injectable({
  providedIn: 'root'
})
export class FirebaseSSRConfigService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() private afAuth: AngularFireAuth,
    @Optional() private afs: AngularFirestore,
    @Optional() private afStorage: AngularFireStorage,
    private notificationService: NotificationService
  ) {
    this.configureFirebaseForSSR();
  }

  private configureFirebaseForSSR() {
    if (isPlatformBrowser(this.platformId)) {
      // Browser environment - configure persistence
      this.configureBrowserPersistence();
    } else {
      // Server environment - disable persistence
      this.configureServerPersistence();
    }
  }

  private configureBrowserPersistence() {
    // Browser-specific Firebase configuration
    if (this.afAuth) {
      // Set persistence for browser
      this.afAuth.setPersistence('local').catch(() => {
        this.notificationService.showWarning('Failed to set auth persistence');
      });
    }
  }

  private configureServerPersistence() {
    // Server-specific Firebase configuration
    if (this.afAuth) {
      // Disable persistence for server
      this.afAuth.setPersistence('none').catch(() => {
        this.notificationService.showWarning('Failed to set auth persistence for server');
      });
    }
  }

  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  get auth(): AngularFireAuth | null {
    return this.isBrowser ? this.afAuth : null;
  }

  get firestore(): AngularFirestore | null {
    return this.isBrowser ? this.afs : null;
  }

  get storage(): AngularFireStorage | null {
    return this.isBrowser ? this.afStorage : null;
  }
}
